import React, { FunctionComponent } from 'react'
import Svg, { Path } from 'react-native-svg'

type LaptopIllustrationProps = {
  size?: number
}

export const LaptopIllustration: FunctionComponent<LaptopIllustrationProps> = ({ size = 45 }) => {
  return (
    <Svg width={size} height={size} viewBox='0 0 45 45' fill='none'>
      <Path
        d='M22.658.152c-3.106 0-6.12.533-8.957 1.583C6.945 4.239 2.196 9.79.67 16.965c-1.009 4.68-.88 9.006.396 13.223 1.63 5.385 5.628 9.927 10.972 12.46 2.652 1.26 5.7 1.979 9.056 2.137.431.02.87.03 1.305.03 2.693 0 5.402-.369 8.052-1.096.203-.05.397-.103.602-.164 2.381-.697 4.524-1.8 6.358-3.273 1.99-1.591 3.63-3.608 4.866-5.991.243-.47.476-.964.733-1.555 1.414-3.283 2.097-6.959 1.976-10.633-.057-1.625-.298-3.352-.716-5.137-.689-2.897-1.81-5.622-3.246-7.884a21.913 21.913 0 00-1.112-1.577c-2.58-3.328-6.599-5.663-11.62-6.75A26.62 26.62 0 0022.66.154V.152z'
        fill='#FFE9E3'
      />
      <Path
        d='M33.5 14.113v15.774a.6.6 0 01-.588.613H12.088a.603.603 0 01-.588-.613V14.113a.6.6 0 01.588-.613h20.824c.324 0 .588.275.588.613z'
        fill='#3BA5B5'
      />
      <Path
        d='M31.5 16.005v12.99a.493.493 0 01-.48.505H13.98a.495.495 0 01-.48-.505v-12.99c0-.279.215-.505.48-.505h17.04c.264 0 .48.226.48.505z'
        fill='#85CCD5'
      />
      <Path
        d='M27.466 30.5h-9.964c-.003-1.994-.077-4.78 1.202-5.953.51-.47 1.659-1.236 2.242-1.004 2.066.821 2.76.22 3.566.025.789-.191 1.93.773 2.343 1.38.77 1.133.658 3.69.61 5.552zM25.5 20c0 1.314-1.12 2.5-2.5 2.5s-2.5-1.186-2.5-2.5 1.12-2.5 2.5-2.5 2.5 1.186 2.5 2.5z'
        fill='#3BA5B5'
      />
      <Path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M7.5 30c0-.828.743-1.5 1.659-1.5h26.682c.916 0 1.659.672 1.659 1.5s-.743 1.5-1.659 1.5H9.159c-.916 0-1.659-.672-1.659-1.5z'
        fill='#3BA5B5'
      />
    </Svg>
  )
}
